export const breakpoints = {
  sm: '40em',
  md: '52em',
  lg: '64em',
  xl: '80em',
  '2xl': '85em',
  '3xl': '90em',
  '4xl': '100em',
  '5xl': '110em',
  '6xl': '120em',
  '7xl': '130em',
  '8xl': '140em',
  '9xl': '150em',
  '10xl': '160em',
};
